import styled from '@emotion/styled';
import { NTA_COLORS, NTA_PAGE_PADDING_X } from '../constants';
import { ntaButtonCss, ntaIntroCss, ntaPageCss } from '../typography';

export const Page = styled.div`
  width: 100vw;
  height: 100vh;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  background: ${NTA_COLORS.white};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${ntaPageCss}
`;

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  padding: 0 ${NTA_PAGE_PADDING_X} 24px;
  box-sizing: border-box;
`;

export const Inner = styled.div`
  width: 100%;
  max-width: 1152px;
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const PostSubmitMessage = styled.p`
  margin: 0;
  width: 100%;
  text-align: center;
  color: ${NTA_COLORS.textPrimary};
  ${ntaIntroCss}
  letter-spacing: 0;
`;

export const PostSubmitButtonRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const PostSubmitButton = styled.button`
  width: ${({ $width }) => $width};
  height: 40px;
  padding: 0 12px;
  border: 1px solid ${NTA_COLORS.confirmButtonBorder};
  background: ${NTA_COLORS.white};
  color: ${NTA_COLORS.textPrimary};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  box-sizing: border-box;
  ${ntaButtonCss}

  &:focus-visible {
    outline: 2px solid ${NTA_COLORS.accentBlue};
    outline-offset: 2px;
  }
`;
